import React from 'react';
import { Text, Stack } from '@chaser/components';
import FileUploadErrorsList from './ErrorsList';
import errorIcon from '../../assets/error.svg';

/**
 * An error information component for file uploads.
 *
 * @param {Object} props - The component props.
 * @param {Object|Error} props.error - An object containing error information. See also {@link FileUploadErrorsList}.
 * @param {Boolean} [props.error.expose] - Whether to expose detailed error information. If falsy, will display a generic error message.
 *
 * @return {JSX.Element} A JSX element representing the error.
 * @see {@link FileUploadErrorsList}
 */
const FileUploadInfoError = ({ error }) => {
  return (
    <Stack gap="small" color="Red AA" alignItems="center">
      <svg width="30" height="30">
        <use href={`${errorIcon}#icon`} x="0" y="0" fill="currentColor" />
      </svg>
      <Text fontWeight="bold" color="inherit">
        Error
      </Text>
      {error.expose ? (
        <FileUploadErrorsList
          message={error.message}
          rejectedFiles={error.rejectedFiles}
          summary={error.summary}
        />
      ) : (
        <Text color="inherit">We're sorry, an error occurred. Please try again.</Text>
      )}
    </Stack>
  );
};

export default FileUploadInfoError;
